import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// Polyfills pour modules Node.js core (requis par bcryptjs, xml-js, etc.)
import { Buffer } from 'buffer';
import process from 'process';
window.Buffer = Buffer;
window.process = process;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.Fragment>
    <App />
  </React.Fragment>
);
